var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76.026,
    viewBox: "0 0 76 76.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M63.163,9.192a7.6,7.6,0,0,1,11.3,0l7.634,8.482a2.533,2.533,0,0,1-3.766,3.389L71.345,13.3V34.568a2.533,2.533,0,1,1-5.067,0V13.3l-6.984,7.76a2.533,2.533,0,1,1-3.766-3.389ZM27.012,11.768a15.2,15.2,0,0,0-15.2,15.2V62.435q0,.731.068,1.445l5.745-9.192A17.733,17.733,0,0,1,46.2,52.632l6.547,7.737a14.968,14.968,0,0,1,24.932.219V44.7a2.533,2.533,0,1,1,5.067,0V62.435A20.267,20.267,0,0,1,62.478,82.7H27.012A20.267,20.267,0,0,1,6.745,62.435V26.968A20.267,20.267,0,0,1,27.012,6.7H49.178a2.533,2.533,0,0,1,0,5.067Z",
    transform: "translate(-6.745 -6.676)",
    fill: "#00b26b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.9e319298341799ca840b472d8703379f.svg";
export { ForwardRef as ReactComponent };